import { useStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { gameStateStore as t } from "@magnopus/space-state";
//#region src/lib/stores/game-store/useGameStore.ts
var n = (n) => e(t, n);
//#endregion
export { n as useGameStore };
